var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('v-alert',{class:`alerttop ${_vm.classes}`,attrs:{"border":_vm.border,"colored-border":"","icon":_vm.icon,"elevation":"2"},domProps:{"innerHTML":_vm._s(_vm.html)}}):_c('v-alert',{class:`alerttop ${_vm.classes}`,attrs:{"border":_vm.border,"colored-border":"","icon":_vm.icon,"elevation":"2"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }